import { render, staticRenderFns } from "./UserMenuDropdown.vue?vue&type=template&id=f3cc3118&scoped=true"
import script from "./UserMenuDropdown.vue?vue&type=script&lang=ts"
export * from "./UserMenuDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cc3118",
  null
  
)

export default component.exports